import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) =>
  createStyles({
    banner: {
      '&.MuiBox-root': {
        display: 'flex',
        flexDirection: 'column',
      },
    },
    issueRow: {
      padding: '23px 24px',
      display: 'flex',
      justifyContent: 'center',
      gap: theme.spacing(2),
      background: '#EB5757',
      color: '#fff',
      boxSizing: 'border-box',
      'border-bottom': '2px solid #CD5944',
      boxShadow: '0px 0px 10px 5px rgba(0, 0, 0, 0.15)',
      '&:not(:last-child)': {
        boxShadow: 'none',
        borderBottom: '1px solid #fff',
      },
      '&&': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        maxWidth: '130rem',
        width: '100%',
        [theme.breakpoints.down('md')]: {
          flexDirection: 'column',
          alignItems: 'flex-start',
        },
      },
    },
    textContent: {
      '&&': {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: theme.spacing(1.5),
        flex: 1,
        minWidth: 0,
      },
    },
    title: {
      '&&': {
        fontWeight: 700,
        fontSize: '1rem',
        lineHeight: 1.4,
        color: '#FFF',
      },
    },
    description: {
      '&&': {
        fontSize: '1rem',
        lineHeight: 1.4,
        color: 'rgba(255, 255, 255, 1)',
      },
    },
    link: {
      '&&': {
        color: '#fff',
        fontWeight: 700,
        textDecoration: 'underline',
        '&:hover': {
          color: '#fff',
        },
      },
    },
    cta: {
      '&&': {
        whiteSpace: 'nowrap',
        color: '#fff',
        borderColor: '#fff',
        display: 'flex',
        height: '30px',
        minHeight: '30px',
        padding: '5px 10px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        borderRadius: '5px',
        border: '1px solid #FFF',
        fontSize: '1rem',
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 1.5,
        textTransform: 'capitalize',
        '&&:hover': {
          borderColor: '#fff',
          color: '#1A0063',
          backgroundColor: '#fff',
        },
        '&.Mui-disabled': {
          color: 'rgba(255, 255, 255, 0.7)',
          borderColor: 'rgba(255, 255, 255, 0.5)',
        },
      },
    },
    actions: {
      '&&': {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1.5),
        [theme.breakpoints.down('md')]: {
          flexDirection: 'column',
          alignItems: 'flex-start',
          width: '100%',
        },
      },
    },
    remindCta: {
      '&&': {
        color: '#fff',
        fontWeight: 700,
        textTransform: 'capitalize',
        padding: '5px 0',
        minHeight: '30px',
        height: '30px',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'transparent',
          textDecoration: 'underline',
        },
      },
    },
    checkboxLabel: {
      '&&': {
        fontSize: '0.95rem',
        marginLeft: 0,
        color: '#fff',
        '& .MuiFormControlLabel-label': {
          fontSize: '0.95rem',
        },
        '.MuiTypography-root': {
          fontSize: '0.95rem',
          lineHeight: 1.4,
        },
      },
    },
    checkbox: {
      '&&': {
        color: '#fff',
        paddingTop: 0,
        paddingLeft: 0,
        paddingBottom: 0,
        '& svg': {
          fill: '#fff',
        },
        '&.Mui-checked': {
          color: '#fff',
        },
      },
    },
  })
)

export default useStyles
